import { createContext } from 'react'

const InitialValuesContext = createContext(null)

export default InitialValuesContext
